import { render, staticRenderFns } from "./Callcentre.vue?vue&type=template&id=b990c520&scoped=true&"
import script from "./Callcentre.vue?vue&type=script&lang=js&"
export * from "./Callcentre.vue?vue&type=script&lang=js&"
import style0 from "./Callcentre.vue?vue&type=style&index=0&id=b990c520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b990c520",
  null
  
)

export default component.exports